import { Controller } from 'react-hook-form'

import { FormsLayout } from 'components/Layout/Forms'
import { InputField } from 'components/InputField'
import Button from 'components/Button'

import { useMemberIdentificationsAddLogin } from './useMemberIdentificationsAddLogin'
import { useMemberIdentificationsAddLoginForm } from './useMemberIdentificationsAddLoginForm'

const Index = ({

  modalClose,
}: {
  modalClose: () => void
}): JSX.Element => {
  const {
    memberIdentificationsAddLoginParams,
    memberHandleIdentificationsAddLogin,
  } = useMemberIdentificationsAddLogin({
    modalClose,
  })

  const { control, handleSubmit, errors } =
    useMemberIdentificationsAddLoginForm({
      defaultValues: memberIdentificationsAddLoginParams,
    })

  return (
    <>
      <FormsLayout.Wrapper
        onSubmit={handleSubmit(memberHandleIdentificationsAddLogin)}
      >
        <FormsLayout.Item>
          <Controller
            name="ident"
            control={control}
            render={({ field }) => (
              <InputField
                {...field}
                type="input"
                name="ident"
                label="Username"
                containerClassName="flex flex-col flex-grow"
                rounded
                error={errors.ident?.message}
                onChange={(e) => {
                  field.onChange(String(e.target.value))
                }}
              />
            )}
          />
        </FormsLayout.Item>

        <FormsLayout.Item>
          <Controller
            name="password"
            control={control}
            render={({ field }) => (
              <InputField
                {...field}
                type="password"
                name="password"
                label="Password"
                containerClassName="flex flex-col flex-grow"
                rounded
                error={errors.password?.message}
                onChange={(e) => {
                  field.onChange(String(e.target.value))
                }}
              />
            )}
          />
        </FormsLayout.Item>

        <FormsLayout.ActionWrapper>
          <Button
            key="submit"
            type="submit"
            className="rounded bg-primary tracking-wider font-bold"
          >
            Add Login
          </Button>
        </FormsLayout.ActionWrapper>
      </FormsLayout.Wrapper>

    </>
  )
}

export default Index
